import { render } from "./VacationRequestsMain.vue?vue&type=template&id=7ea15742"
import script from "./VacationRequestsMain.vue?vue&type=script&lang=js"
export * from "./VacationRequestsMain.vue?vue&type=script&lang=js"

import "./VacationRequestsMain.vue?vue&type=style&index=0&id=7ea15742&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__